import {
  MARKET_MODES,
  MARKET_MODE_STATUS,
  Market
} from "../market";

const OZON_FAQ = [
  {
    title: "Что такое пользовательский сценарий взаимодействия с карточкой товара?",
    isH3: true,
    text: (
      <div>
        Пользовательский сценарий — это заранее заданная последовательность действий, которую реальный пользователь может выполнить при взаимодействии с карточкой товара на маркетплейсе. 
        <br />
        Такие действия могут включать:
        <br />
        <br />
        <ul>
          <li>Поиск товара по ключевым словам</li>
          <li>Изучение карточки: описание, характеристики, фото</li>
          <li>Добавление товара в избранное или корзину (по условиям задания)</li>
          <li>Анализ цен, отзывов, сопутствующих товаров</li>
        </ul>
        <br />
        Сценарии позволяют получить обратную связь о восприятии карточки товара, а также собрать данные о том, какие элементы привлекают внимание пользователей.
      </div>
    ),
  },
  {
    title: "Зачем нужны пользовательские сценарии?",
    isH3: true,
    text: (
      <div>
        <ul>
          Такой формат взаимодействия помогает:
          <br />
          <br />
          <li>Проверить, насколько легко найти товар по определенным запросам</li>
          <li>Понять, какие элементы карточки вызывают интерес или вопросы</li>
          <li>Получить данные для улучшения структуры и содержания страницы</li>
          <li>Смоделировать типичное поведение потенциального покупателя</li>
        </ul>
        <br />
        Исполнители получают индивидуальные задания и делятся отчетами по завершении. Это позволяет оценить путь пользователя и при необходимости оптимизировать карточку.
      </div>
    ),
  },
  {
    title: "Кто выполняет задания?",
    isH3: true,
    text: (
      <p>
        Задания исполняют реальные пользователи, заинтересованные в тестировании. 
        <br />
        Каждый из них работает вручную по индивидуальной инструкции. 
        <br />
        Все задания проходят модерацию и могут быть отклонены, если не соответствуют условиям.
        <br />
        <br />
        <b>Важно</b>
        <br />
        • Все сценарии — это исследовательский инструмент, а не гарантия продвижения или роста продаж
        <br />
        • Boostclick не оказывает услуги по продвижению на Ozon* и не влияет на алгоритмы ранжирования
        <br />
        • Весь процесс направлен на анализ и сбор пользовательского опыта
      </p>
    ),
  },
];

const STEP_TWO_TITLE_FAQ = (
  <p>
    Почему при добавлении одного действия в калькуляторе появляются
    дополнительные действия?
    <br />
    <br />
    Сервис формирует уникальные сценарии для каждого исполнителя, и каждый
    сценарий начинается для нового исполнителя с поиска товара по сделанному
    скриншоту вашей ссылки.
  </p>
);

const REVIEW_PRICE = 250;

const ACTIONS = [
  {
    type: "MAIN.FAVORITE",
    icon: "heart",
    iconHome: "home-heart",
    title: "Добавить товар в избранное",
    initialShare: 0.5,
    activityType: 'Избранное',
  },
  {
    type: "MAIN.STAR",
    icon: "star",
    iconHome: "home-star",
    title: "Добавить бренд в избранное",
    initialShare: 0.2,
    activityType: 'Избранное',
  },
  {
    type: "MAIN.BUSKET",
    icon: "busket",
    iconHome: "home-busket",
    title: "Добавить товар в корзину",
    initialShare: 0.2,
    activityType: 'Корзина',
  },
  {
    type: "MAIN.LIKE",
    icon: "like",
    iconHome: "home-like",
    title: "Поставить положительную реакцию на отзыв",
    initialShare: 0.1,
    activityType: 'Лайк',
  },

  {
    type: "ALWAYS.OPEN",
    icon: "open",
    iconHome: "home-open",
    title: "Открыть сайт или приложение OZON",
    initialShare: 1,
  },
  {
    type: "ALWAYS.SEARCH",
    icon: "search",
    iconHome: "home-search",
    title: "Найти товар через поиск OZON",
    initialShare: 1,
  },
  {
    type: 'ALWAYS.COMPETITORS',
    icon: "time",
    iconHome: "home-time",
    title: 'Быстро просмотреть конкурентов',
    initialShare: 1,
  },
  {
    type: "ALWAYS.CLICK",
    icon: "click",
    iconHome: "home-click",
    title: "Зайти на карточку товара",
    initialShare: 1.0,
  },

  {
    type: "EXTRA.MEDIA",
    icon: "eye",
    iconHome: "home-eye",
    title: "Посмотреть все фото и видео на карточке",
    initialShare: 0.6,
  },
  {
    type: "EXTRA.DESCRIPTION",
    icon: "glasses",
    iconHome: "home-glasses",
    title: "Прочитать полное описание",
    initialShare: 0.2,
  },
  {
    type: "EXTRA.GOODS",
    icon: "click",
    iconHome: "home-click",
    title: "Посмотреть другие товары продавца",
    initialShare: 0.1,
  },
  {
    type: "EXTRA.FEEDBACKS",
    icon: "glasses",
    iconHome: "home-glasses",
    title: "Прочитать отзывы на товар",
    initialShare: 0.1,
  },
  {
    type: "MAIN.DISLIKE",
    icon: "dislike",
    iconHome: "home-dislike",
    title: "Поставить отрицательную реакцию на отзыв",
    initialShare: 0,
    activityType: 'Дизлайк',
    hidden: true,
  },
  {
    type: "MAIN.APPEAL",
    icon: "dislike",
    iconHome: "home-dislike",
    title: "Пожаловаться на последний отзыв",
    initialShare: 0,
    activityType: 'Жалоба',
    hidden: true,
  },
];

const MAIN_PAGE_TITLES = [
  {
    iconHome: "home-action",
    title: "Поведенческая активность",
    titleComment: "Изучение товаров",
    path: "/povedencheskie-faktory-na-ozon",
    target: '_self',
    statusForHomePage: MARKET_MODE_STATUS.HIT,
  },
  {
    iconHome: "home-heart",
    title: "В избранное",
    path: "/povedencheskie-faktory-na-ozon",
    target: '_self',
  },
  {
    iconHome: "home-star",
    title: "В избранное (бренд)",
    path: "/povedencheskie-faktory-na-ozon",
    target: '_self',
  },
  {
    iconHome: "home-busket",
    title: "В корзину",
    path: "/povedencheskie-faktory-na-ozon",
    target: '_self',
  },
  {
    iconHome: "home-like",
    title: "Оценить отзыв",
    path: "/povedencheskie-faktory-na-ozon",
    target: '_self',
  },
  {
    iconHome: "home-open",
    title: "Переход по ссылке",
    path: "/povedencheskie-faktory-na-ozon",
    target: '_self',
  },
  {
    iconHome: "home-search",
    title: "Найти товар",
    path: "/povedencheskie-faktory-na-ozon",
    target: '_self',
  },
  {
    iconHome: "home-glasses",
    title: "Сравнение товаров",
    path: "/povedencheskie-faktory-na-ozon",
    target: '_self',
  },
  {
    iconHome: "home-click",
    title: "Карточка товара",
    path: "/povedencheskie-faktory-na-ozon",
    target: '_self',
  }
];

const STEP_PHRASE_2 = "Укажите информацию для поиска товара";

const OZON_KEYWORDS = [
  'Ozon', 'ozon', 'Озон', 'озон'
];

class OzonClass extends Market {
  id = "ozon";
  host = "ozon.ru";
  url = "https://ozon.ru/";

  title = "OZON";

  isMarketplace = true;

  icon = "ozon";
  titlePlaces = "OZON";
  statusForHomePage = MARKET_MODE_STATUS.POPULAR;
  mainPageTitles = MAIN_PAGE_TITLES;

  categories = [
    { type: "Электроника" },
    { type: "Одежда" },
    { type: "Обувь" },    
    { type: "Дом и сад" },
    { type: "Детские товары" },
    { type: "Красота и здоровье" },
    { type: "Бытовая техника" },
    { type: "Спорт и отдых" },
    { type: "Строительство и ремонт" },
    { type: "Продукты питания" },
    { type: "Аптека" },
    { type: "Товары для животных" },
    { type: "Книги" },
    { type: "Туризм, рыбалка, охота" },
    { type: "Автотовары" },
    { type: "Мебель" },
    { type: "Хобби и творчество" },
    { type: "Ювелирные украшения" },
    { type: "Аксессуары" },
    { type: "Игры и консоли" },
    { type: "Канцелярские товары" },
    { type: "Антиквариат и коллекционирование" },
    { type: "Цифровые товары" },
    { type: "Бытовая химия и гигиена" },
    { type: "Музыка и видео" },
    { type: "Автомобили" },
  ];

  chainsPerDayNormal = 200 / 30;

  chainPrice = 24;
  chainsMin = 4;
  chainsMax = 250;

  chainsDefault = 10;

  reviewPrice = REVIEW_PRICE;

  chainsStep = 1;
  viewsStep = 10;

  keywords = OZON_KEYWORDS;

  targetLinkComment = "Укажите тут адрес вашего товара на OZON";
  targetLinkCommentShort = "Укажите ссылку товара";

  modes = [
    {
      id: MARKET_MODES.CHAINS,
      path: "/povedencheskie-faktory-na-ozon",
      rating: 0.968,
      title: "ПФ",
      navigateTitle: "Поведение и тест карточек товаров",
      icon: "lightning",
      iconForHomePage: "home-action",
      status: MARKET_MODE_STATUS.NEW,
      meta: {
        title: "Накрутка ПФ ЛЮДИ на OZON — просмотры, лайки | Boostclick",
        description: "Накрутка ПФ ЛЮДИ на OZON — просмотры, добавления.",
        canonical: '/povedencheskie-faktory-na-ozon',
      },
      intro: {
        title: "Продвижение карточек на OZON* через ПФ",
        comment: "Только реальные пользователи и естественное взаимодействие:",
        points: [
          'Действия от пользователей с историей покупок на Ozon*',
          'Возможность выявить слабые места и улучшить позиционирование карточки',
          'Отложенная оплата — только после подтверждения отчета',
          'Потенциальное влияние на поведенческие сигналы: интерес к товару, глубина просмотра, переходы по ключам',
          'Без ботов и автоматизации — только живое участие',
        ],
      },
      howItWorks: [
        /* "Настройте параметры активности в соответствии с конкуренцией",
        "Укажите ссылку на товар для скриншота",
        "Укажите категорию, город и ключевые фразы из карточки товара",
        "После оплаты мы передадим исполнителю скриншот и параметры для поиска",
        "Проверьте ответы и активность, примите работу или отправьте на доработку", */
      ],
      stepPhrase1: "Настройте параметры взаимодействия пользователей с карточками на Ozon*",
      stepPhrase2: STEP_PHRASE_2,
      stepTwoTitleFaq: STEP_TWO_TITLE_FAQ,
      calculatorTitle: "Продвижение на Ozon* через взаимодействие пользователей",
      titleFAQ: "Вопрос-ответ про накрутку просмотров на Озон",
      faq: OZON_FAQ,
      // article: OZON_ARTICLE,
      actions: (() => {
        return [
          ...ACTIONS.filter(
            (action) =>
              action.type !== "MAIN.REVIEW" && !action.type.startsWith("VIEW.")
          ),
          ...ACTIONS.filter((action) => action.type === "MAIN.REVIEW"),
        ];
      })(),
      notice: [
        'Сервис создает задания для тестировщиков с индивидуальными сценариями взаимодействия.',
        'Цепочки действий формируются на основе заданных вами параметров: поисковых запросов, категории, интересующих действий.',
        'Каждому исполнителю выдается уникальное задание, которое предполагает:',
        '– Поиск товара по ключевой фразе',
        '– Переход на карточку и изучение контента',
        '– Добавление в избранное или корзину (по вашему выбору)',
        '– Взаимодействие с похожими товарами или фильтрами (если указано)',
        'Сценарии помогают собрать обратную связь и проанализировать, как пользователь воспринимает карточку товара в естественных условиях.',
        'Сложность заданий и сроки выполнения зависят от количества сценариев и действий в проекте.',
      ],
    },
  ];

  actionsMap = ACTIONS.reduce((map, action) => {
    map[action.type] = action;
    return map;
  }, {});

  emptyUrlStr = 'Укажите ссылку на товар';
  invalidUrlStr = 'Укажите корректную ссылку на товар';
}

const Ozon = new OzonClass();
export default Ozon;
